import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/css/icons.css";
import "../../assets/css/style.css";
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from "../../Server";
import axios from "axios";
import { DeleteIcon, EditIcon, HomeIcon, PLusIcon } from "../../assets/Icons";
import TableSkelton from "../../skeltonloader/TableSkelton";
import NoDataFound from "../../common/NoDataFound";
import { NavLink } from "react-router-dom/cjs/react-router-dom";
import Swal from "sweetalert2";

class ListMcq extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      List: [],
      message: "",
      searchVal: "",
      loading: false,
    };
  }

  componentDidMount() {
    this.getList();
  }
  getList = () => {
    this.setState({ loading: true });
    var data = {
      sid: ud.main_id,
    };
    let _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/bank/MCQList`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.data.error === false) {
          if (response.data.listMCQ) {
            _this.setState({
              List: response.data.listMCQ,
              message: response.data.listMCQ.length === 0 ? "No Record Found." : "",
            });
          }
        } else {
          auth_response_flow(response.data, (return_response) => {
            if (return_response.error === false && return_response.retry === true) {
              _this.getList();
            }
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => this.setState({ loading: false }));
  };

  deleteMCQ = (mcq_Id) => {
    let _this = this;
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        var data = {
          id: mcq_Id,
        };
        let headers = {
          user_id: ud.id.toString(),
          session_id: ud.session_id.toString(),
          user_type: ud.usertype.toString(),
          main_id: ud.main_id.toString(),
          jwt_token: jwt,
          c_id: ud.c_id.toString(),
        };
        axios
          .post(`${SERVER_IP}/bank/deleteMCQ`, data, { withCredentials: true, headers: headers })
          .then(function (response) {
            _this.getList();
            if (response.data.error === false) {
              Swal.fire({
                title: "Success",
                text: result.msg,
                icon: "success",
                confirmButtonText: "Ok",
              });
            } else {
              Swal.fire({
                title: "Error",
                text: result.msg,
                icon: "error",
                confirmButtonText: "Ok",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    });
  };

  createBank = () => {
    window.location.href = "/create/mcqbankcreate";
  };
  EditMcq = (list) => {
    sessionStorage.setItem("mcq_bank_edit", JSON.stringify(list));
    window.location.href = "/create/mcqbankedit";
  };

  render() {
    const { errors } = this.state;
    return (
      <div className="pt-3">
        <div class="xp-breadcrumbbar">
          <h4 className="mb-3">Library</h4>
          <div class="row">
            <div class="col-md-10 col-lg-10">
              <div class="xp-breadcrumb gradient-border mt-0">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a onClick={() => (window.location.href = "/dashboard")}>
                      <i>
                        <HomeIcon />{" "}
                      </i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active" aria-current="page">
                    MCQ bank list
                  </li>
                </ol>
              </div>
            </div>
            <div class="col-md-2 col-lg-2 text-right">
              <NavLink
                className="btn btn-white btn-lg rounded border p-11"
                title="Create MCQ Library"
                // onClick={this.createBank}
                to="/create/mcqbankcreate"
              >
                <PLusIcon /> <span className="pl-1">Create MCQ</span>
              </NavLink>
            </div>
          </div>
        </div>
        <div class="xp-contentbar p-30">
          <div class="row">
            <div class="col-lg-12">
              <div class="card document_gradient_border padding-0 m-b-30">
                <div class="card-header dv-center space-between border-radius-top-15">
                  <h5 class="card-title mb-0">Multiple Choice Question List</h5>
                  {/* <div className="autocomplete_search">
                                            <input type="text" className="form-control ml-2" onChange={this.search_bar} name="" value={this.state.searchVal} placeholder="Search Workflow ..." />
                                            {this.state.searchVal === "" ?
                                                <span className="icon-search">
                                                    <svg focusable="false" height="24px" viewBox="0 0 24 24" width="24px" xmlns="http://www.w3.org/2000/svg"><path d="M20.49,19l-5.73-5.73C15.53,12.2,16,10.91,16,9.5C16,5.91,13.09,3,9.5,3S3,5.91,3,9.5C3,13.09,5.91,16,9.5,16 c1.41,0,2.7-0.47,3.77-1.24L19,20.49L20.49,19z M5,9.5C5,7.01,7.01,5,9.5,5S14,7.01,14,9.5S11.99,14,9.5,14S5,11.99,5,9.5z"></path><path d="M0,0h24v24H0V0z" fill="none"></path></svg>
                                                </span>
                                                :
                                                <span className="icon-close-search">
                                                    <svg focusable="false" height="24px" onClick={this.closeSearch} viewBox="0 0 24 24" width="24px" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path><path d="M0 0h24v24H0z" fill="none"></path></svg>
                                                </span>
                                            }
                                        </div> */}
                </div>

                <div class="card-body">
                  <div class="table-responsive">
                    {/* {this.state.List.length === 0 ? (
                      this.state.message === "" ? (
                        // loader
                        <div className="lds-spinner">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      ) : (
                        // loader-end
                        <div className="message-no-record"> {this.state.message} </div>
                      )
                    ) : null} */}
                    <table class="table table-striped table-bordered mcqlist-taable">
                      <thead>
                        <tr>
                          <th className="text-center">S.No</th>
                          <th>Question</th>
                          <th className="text-center">Option 1 (Correct)</th>
                          <th className="text-center">Option 2 (Wrong)</th>
                          <th className="text-center">Option 3 (Wrong)</th>
                          <th className="text-center">Option 4 (Wrong)</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loading ? (
                          <TableSkelton rowCount={3} colCount={7} />
                        ) : this.state.List.length === 0 ? (
                          <tr>
                            <td colSpan={7}>
                              <NoDataFound headText={"No MCQ Found"} />
                            </td>
                          </tr>
                        ) : (
                          // <tr>
                          //   <td colSpan="7" className="text-center py-5">
                          //     <NoDataFound headText={this.state.message || "No Record Found."}/>
                          //   </td>
                          // </tr>
                          this.state.List.map((list, index) => (
                            <tr>
                              <td className="text-center">
                                <strong>{index + 1}.</strong>
                              </td>
                              <td>{list.question}</td>
                              <td className="text-center">{list.correct}</td>
                              <td className="text-center">{list.alternative_1}</td>
                              <td className="text-center">{list.mcq_type === 2 ? "-" : list.alternative_2}</td>
                              <td className="text-center">{list.mcq_type === 2 ? "-" : list.alternative_3}</td>
                              <td className="text-center">
                                <div
                                  class="tabledit-toolbar btn-toolbar"
                                  style={{ margin: "0 auto", display: "block" }}
                                >
                                  <div class="btn-group btn-group-sm align-items-center">
                                    <NavLink
                                      type="button"
                                      title="Edit"
                                      // onClick={() => this.EditMcq(list)}
                                      class=" btn  btn-info"
                                      onClick={() => sessionStorage.setItem("mcq_bank_edit", JSON.stringify(list))}
                                      to="/create/mcqbankedit"
                                    >
                                      <i>
                                        <EditIcon />
                                      </i>
                                    </NavLink>
                                    {/* <span className="pl-3" type="button" title="Delete">
                                      <i>
                                        <DeleteIcon />
                                      </i>
                                    </span> */}
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                  {/* <nav aria-label="Page navigation example">
                                  <ul class="pagination justify-content-end">
                                    <li class="page-item disabled">
                                      <a class="page-link" href="#" tabindex="-1">Previous</a>
                                    </li>
                                    <li class="page-item"><a class="page-link" href="#">1</a></li>
                                    <li class="page-item"><a class="page-link" href="#">2</a></li>
                                    <li class="page-item"><a class="page-link" href="#">3</a></li>
                                    <li class="page-item">
                                      <a class="page-link" href="#">Next</a>
                                    </li>
                                  </ul>
                                </nav> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default ListMcq;
